module.exports = __webpack_public_path__ + "static/media/Octocat-v2.00ce2799.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/Octocat-v2.svg
// module id = 266
// module chunks = 0